import { businessInfo } from "../data/mock";

// Opens a new window with a styled, printable coupon and auto-triggers print.
export const printCoupon = () => {
  const today = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

  const html = `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<title>Hamilton's Smog - $7 Off Coupon</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { height: 100%; font-family: 'Helvetica Neue', Arial, sans-serif; color: #0f172a; background: #f1f5f9; }
  body { display: flex; align-items: center; justify-content: center; padding: 24px; }
  .coupon {
    width: 700px; max-width: 100%; background: #ffffff;
    border: 3px dashed #16a34a; border-radius: 18px;
    position: relative; overflow: hidden;
    box-shadow: 0 20px 40px -20px rgba(15, 23, 42, 0.25);
  }
  .brand-bar {
    background: #0f172a; color: #ffffff; padding: 18px 28px;
    display: flex; align-items: center; justify-content: space-between;
  }
  .brand-bar .logo {
    display: flex; align-items: center; gap: 12px;
  }
  .logo-mark {
    width: 46px; height: 46px; border-radius: 10px;
    background: #16a34a; color: #ffffff;
    display: flex; align-items: center; justify-content: center;
    font-weight: 900; font-size: 16px; letter-spacing: 0.5px;
  }
  .brand-name { font-weight: 900; letter-spacing: 0.5px; font-size: 18px; }
  .brand-sub { font-size: 11px; opacity: 0.7; letter-spacing: 1px; text-transform: uppercase; margin-top: 2px; }
  .star-badge {
    background: #16a34a; color: #ffffff;
    font-size: 11px; font-weight: 800; padding: 6px 12px;
    border-radius: 999px; letter-spacing: 1px;
  }
  .body {
    padding: 40px 32px 32px; text-align: center;
    background: linear-gradient(180deg, #ffffff 0%, #f0fdf4 100%);
  }
  .eyebrow { color: #16a34a; font-weight: 800; letter-spacing: 3px; font-size: 12px; margin-bottom: 8px; }
  .headline {
    font-size: 64px; font-weight: 900; color: #0f172a;
    line-height: 1; letter-spacing: -1.5px; margin-bottom: 8px;
  }
  .headline .amount { color: #16a34a; }
  .sub { font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 20px; }
  .desc { color: #475569; font-size: 14px; max-width: 480px; margin: 0 auto 24px; line-height: 1.6; }
  .details {
    display: grid; grid-template-columns: 1fr 1fr; gap: 12px;
    background: #ffffff; border: 1px solid #e2e8f0; border-radius: 12px;
    padding: 18px 20px; text-align: left; max-width: 520px; margin: 0 auto;
  }
  .detail-label { font-size: 10px; color: #94a3b8; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 800; }
  .detail-value { font-size: 14px; color: #0f172a; font-weight: 700; margin-top: 2px; }
  .fine {
    margin-top: 20px; font-size: 10px; color: #64748b; text-align: center;
    max-width: 520px; margin-left: auto; margin-right: auto; line-height: 1.5;
  }
  .foot {
    background: #0f172a; color: #ffffff; text-align: center;
    padding: 12px; font-size: 12px; letter-spacing: 1px; font-weight: 700; text-transform: uppercase;
  }
  .scissors {
    position: absolute; left: -1px; right: -1px; top: 50%;
    border-top: 2px dashed #cbd5e1; transform: translateY(-50%);
    display: none;
  }
  .btn-bar {
    text-align: center; margin-top: 20px;
  }
  .btn {
    display: inline-block; background: #16a34a; color: #ffffff;
    padding: 10px 22px; border-radius: 8px; font-weight: 800;
    text-decoration: none; border: none; cursor: pointer; font-size: 14px;
  }
  .btn.secondary { background: #0f172a; margin-left: 8px; }

  @media print {
    @page { size: auto; margin: 12mm; }
    body { background: #ffffff !important; padding: 0; }
    .btn-bar { display: none !important; }
    .coupon { box-shadow: none; }
  }
</style>
</head>
<body>
  <div>
    <div class="coupon">
      <div class="brand-bar">
        <div class="logo">
          <div class="logo-mark">HS</div>
          <div>
            <div class="brand-name">HAMILTON'S SMOG</div>
            <div class="brand-sub">STAR Certified &bull; Since 2021</div>
          </div>
        </div>
        <div class="star-badge">★ STAR STATION</div>
      </div>

      <div class="body">
        <div class="eyebrow">EXCLUSIVE COUPON</div>
        <div class="headline"><span class="amount">$7.00 OFF</span></div>
        <div class="sub">Your Next Smog Check!</div>
        <div class="desc">
          Present this coupon at checkout to save on any STAR-certified smog check at Hamilton's Smog in Novato, CA. Combine with our Price Match Guarantee for the best deal in Marin County.
        </div>

        <div class="details">
          <div>
            <div class="detail-label">Location</div>
            <div class="detail-value">${businessInfo.address}</div>
          </div>
          <div>
            <div class="detail-label">Call</div>
            <div class="detail-value">${businessInfo.phone}</div>
          </div>
          <div>
            <div class="detail-label">Call or Text</div>
            <div class="detail-value">${businessInfo.textPhone}</div>
          </div>
          <div>
            <div class="detail-label">Hours</div>
            <div class="detail-value">Mon–Fri 8:30–5:30 • Sat 9–3</div>
          </div>
        </div>

        <div class="fine">
          Valid at Hamilton's Smog only. One coupon per customer per vehicle. Not valid with other offers unless price-matched. No cash value. Issued ${today} &nbsp;•&nbsp; Expires ${expires}.
        </div>

        <div class="btn-bar">
          <button class="btn" onclick="window.print()">Print This Coupon</button>
          <button class="btn secondary" onclick="window.close()">Close</button>
        </div>
      </div>

      <div class="foot">Hamilton's Star Smog Check &nbsp;•&nbsp; Novato, CA &nbsp;•&nbsp; Fastest Smog Check in Marin</div>
    </div>
  </div>
  <script>
    // Auto-trigger print dialog on load
    window.addEventListener('load', function() {
      setTimeout(function() { window.print(); }, 400);
    });
  </script>
</body>
</html>`;

  const win = window.open("", "_blank", "width=780,height=900");
  if (!win) {
    alert("Please allow popups to print your coupon, or take a screenshot of this page.");
    return;
  }
  win.document.open();
  win.document.write(html);
  win.document.close();
};
